import { render } from "./SegundaConferencia.vue?vue&type=template&id=4e0d25f1&scoped=true"
import script from "./SegundaConferencia.vue?vue&type=script&lang=js"
export * from "./SegundaConferencia.vue?vue&type=script&lang=js"

import "./SegundaConferencia.vue?vue&type=style&index=0&id=4e0d25f1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0d25f1"]])

export default __exports__